<template>
  <div class="canceled-wrapper">
    <div class="text-center canceled-title">Paypal payment canceled</div>
    <div class="text-center font-bold">Please go back to fondi to try again.</div>

    <div class="mt-4 text-center">
      <button class="btn-common btn-medium-normal btn-return" @click="backToApp()">
        <v-icon class="mr-2">mdi-arrow-left</v-icon>
        <span class="return-btn-text">Return to fondi</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { AppUrlScheme } from '../../../utils/app_utils';

export default {
  methods: {
    ...mapMutations(['setToken']),

    backToApp() {
      this.setToken(null);
      open(AppUrlScheme);
    },
  },
};
</script>

<style scoped>
.canceled-wrapper {
  min-height: calc(100vh - 100px);
}
.canceled-title {
  color: #404040;
  font-size: 22px;
  font-weight: bold;
}
.btn-return {
  margin-top: 30px;
}
.btn-return > * {
  vertical-align: middle;
}
.return-btn-text {
  font-weight: bold;
  font-size: 16px;
}
</style>
